import React from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import { Transaction } from "../../../types";
import { Banner } from "fe-shared/src/components";
import {
    TransactionSection,
    TransactionSubSection,
    TransactionFlag,
    TransactionFlagLink,
} from "fe-shared-transactions/src/types/details";

import { Link } from "react-router-dom";

import styles from "../DetailsDataSection.module.scss";

const { Data } = TransactionSection;
const { RegulatoryYearOverridden } = TransactionSubSection;

interface Props {
    transaction: Transaction;
}

const RegulatoryYearOverriddenBanner = ({ transaction }: Props) => {
    const { t } = useTranslation();
    const {
        transactionFlags
    } = transaction;

    const flags: TransactionFlag[] = transactionFlags
        .filter(x => x.sectionCode === Data && x.subSectionCode === RegulatoryYearOverridden);

    const hasFlag = flags.length > 0;
    const hasLinks = flags.some(flag => flag.links && flag.links.length > 0);

    const categoryRouteMap: Record<string, string> = {
        Transaction: "transactions",
        Transfer: "transfers",
        InventoryAdjustments: "inventory-adjustments",
    };

    const createLink = (flagLink: TransactionFlagLink) => {
        const route = categoryRouteMap[flagLink.category] || flagLink.category.toLowerCase();
        return `[${flagLink.transactionNumber}](/${route}/${flagLink.transactionNumber})`;
    };


    const formatFlagLinks = (flagLinks: TransactionFlagLink[] | undefined) => (
        flagLinks?.map(flagLink => `${flagLink.transactionTypeName} ${createLink(flagLink)}`).join(', ')
    );

    return (
        <>
            <Banner
                id="regulatory-year-overridden"
                variant="info"
                title={t("transactions.details.regulatoryYearOverridden.title")}
                className={styles.regulatoryYearOverriddenBannerWrapper}
            >
                <div id="regulatory-year-overridden-data-container">
                    {hasFlag && (
                        (hasLinks) ?
                            (flags.map(flag => (
                                <div id={`${flag.sectionCode}${flag.subSectionCode}`}>
                                    <p>{flag.text}</p>
                                    <ReactMarkdown
                                        source={formatFlagLinks(flag.links) || ""}
                                        renderers={{
                                            link: (linkProps) =>
                                                (<Link to={linkProps.href}>{linkProps.children}</Link>)
                                        }}
                                    />
                                </div>))
                            )
                            :
                            (<p>{t("transactions.details.regulatoryYearOverridden.noTransactionsAffected")}</p>)
                    )}
                </div>
            </Banner>
        </>
    );
}

export default RegulatoryYearOverriddenBanner;
